import React, { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { get, post } from "@/lib/api";
import { PageLoader, PageHeader, EmptyState, Badge, statusTone } from "@/components/common";
import { MessageCircleQuestion, Send } from "lucide-react";

export default function TeacherDoubts() {
  const qc = useQueryClient();
  const [reply, setReply] = useState({});
  const { data, isLoading } = useQuery({ queryKey: ["teacher-doubts"], queryFn: () => get("/doubts") });
  const send = async (id) => { if (!reply[id]?.trim()) return; await post(`/doubts/${id}/reply`, { text: reply[id] }); setReply({ ...reply, [id]: "" }); toast.success("Reply sent"); qc.invalidateQueries({ queryKey: ["teacher-doubts"] }); };
  if (isLoading) return <PageLoader />;
  return (
    <div>
      <PageHeader title="Student Doubts" subtitle="Answer questions from students" />
      {!data?.length ? <EmptyState icon={MessageCircleQuestion} title="No doubts" /> : (
        <div className="space-y-3">{data.map((d) => (
          <div key={d.id} className="bg-white rounded-2xl border border-slate-200 p-4">
            <div className="flex items-center justify-between"><p className="font-medium text-slate-800">{d.text}</p><Badge tone={statusTone(d.status)}>{d.status}</Badge></div>
            <p className="text-xs text-slate-400 mt-1">by {d.user_name}</p>
            {(d.responses || []).map((r, i) => <div key={i} className="mt-2 bg-indigo-50 rounded-lg p-2.5 text-sm"><b className="text-indigo-800">{r.by}:</b> {r.text}</div>)}
            <div className="flex gap-2 mt-3"><input value={reply[d.id] || ""} onChange={(e) => setReply({ ...reply, [d.id]: e.target.value })} data-testid={`reply-input-${d.id}`} className="flex-1 border border-slate-200 rounded-lg px-3 py-2 text-sm" placeholder="Type reply..." /><button onClick={() => send(d.id)} data-testid={`reply-btn-${d.id}`} className="bg-indigo-800 text-white px-4 rounded-lg"><Send className="h-4 w-4" /></button></div>
          </div>))}</div>
      )}
    </div>
  );
}
